import React from "react";

import { LatePayrollNotificationsContainer } from "../../../containers";

const LatePayrollNotifications = (props) => {
  return <LatePayrollNotificationsContainer {...props} />;
};

export default LatePayrollNotifications;
